var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkAngled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.879 10.1905L5.64554 12.424C4.81141 13.2581 4.33173 14.3931 4.3405 15.5859C4.34926 16.7787 4.81844 17.9206 5.69216 18.7673C6.53884 19.641 7.68097 20.1102 8.87359 20.119C10.0934 20.1279 11.2015 19.6753 12.0357 18.8411L14.2692 16.6077M17.122 13.8094L19.3554 11.576C20.1896 10.7418 20.6692 9.60687 20.6605 8.41406C20.6517 7.22124 20.1825 6.07936 19.3088 5.23262C18.4623 4.38614 17.3204 3.91693 16.1276 3.90816C14.9348 3.8994 13.7997 4.35185 12.9655 5.18601L10.732 7.41946M9.11359 15.3271L15.814 8.62676",
    stroke: "#657397",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkAngled);
export default __webpack_public_path__ + "static/media/link-angled.33c48cad8906b4d394c09edb17783208.svg";
export { ForwardRef as ReactComponent };